export const FEATURE_LABELS: Record<string, string> = {
  ranking_check: 'Ranking Tracker',
  keyword_check: 'Ranking Tracker',
  audit_crawl: 'Audit Crawl',
  backlinks_check: 'Backlinks',
  onpage_check: 'On-Page',
}

export function featureLabel(action: string): string {
  return FEATURE_LABELS[action] || action.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}
